import { Box, Typography } from '@material-ui/core'
import Button from '@mui/material/Button'
import { useEffect, useState } from 'react'
import { getAssociatedTickets, getTickets } from '../api'
import { useDebounce } from '../../../hooks/useDebounce'
import { FrontPluginLink } from '../FrontPluginLink'
import { TicketCard } from '../components/TicketCard'
import config from '../../../config'
import { ConfirmationModal } from '../components/CreateTicketConfirmationModal'

export const FrontPluginHome = ({ conversation }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [linkedInternalTickets, setLinkedInternalTickets] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [showHomePage, setShowHomePage] = useState(true)
  const [unlinkedInternalTickets, setUnlinkedInternalTickets] = useState([])
  const [openModal, setOpenModal] = useState(false)

  const DEBOUNCE_DELAY = 1000
  const debouncedSearchValue = useDebounce(searchValue, DEBOUNCE_DELAY)

  useEffect(() => {
    if (conversation) {
      getAssociatedTickets(conversation.id).then((data) => {
        setLinkedInternalTickets(data)
      })
    }
  }, [conversation])

  useEffect(() => {
    if (!showHomePage && debouncedSearchValue) {
      setIsLoading(true)
      getTickets(debouncedSearchValue).then((data) => {
        const initialTickets = data.map((ticket) => ({
          ...ticket,
          isChecked: false,
        }))
        setUnlinkedInternalTickets(initialTickets)
        setIsLoading(false)
      })
    }
  }, [showHomePage, debouncedSearchValue])

  const handleOnAddTicketClick = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  if (isLoading) {
    return <Box>Loading...</Box>
  }

  return (
    <Box>
      {!showHomePage ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <FrontPluginLink
            setShowHomePage={setShowHomePage}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            unlinkedInternalTickets={unlinkedInternalTickets}
            currentFrontTicket={conversation}
            setUnlinkedInternalTickets={setUnlinkedInternalTickets}
            setLinkedInternalTickets={setLinkedInternalTickets}
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={() => setShowHomePage(false)}
            fullWidth
            sx={{
              position: 'sticky',
              top: 0,
              boxShadow: '0 0 0 5px white',
              marginBottom: '6px',
            }}
          >
            Rattacher un ticket
          </Button>

          {linkedInternalTickets?.length > 0 ? (
            linkedInternalTickets.map((ticket, index) => (
              <TicketCard
                key={ticket.id}
                ticket={ticket}
                frontTicketId={conversation.id}
                setLinkedInternalTickets={setLinkedInternalTickets}
                linkedTicketsMode
                isLastCard={index === linkedInternalTickets.length - 1}
              />
            ))
          ) : (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
                marginY: '20px',
              }}
            >
              <Typography variant="h6">Aucun ticket rattaché</Typography>
              <img
                src={`${config.PUBLIC_URL}/img/mandy_no-result.png`}
                style={{
                  width: '120px',
                }}
              />
            </Box>
          )}
        </Box>
      )}
      <ConfirmationModal
        frontId={conversation.id}
        handleCloseModal={handleCloseModal}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </Box>
  )
}
